import { h } from 'preact';
import classnames from 'classnames';

export const StepButtons = (props: {
  visibleButtons: { key: string; label: string }[];
  onSelect: (key: string) => void;
  selected?: string;
}) => {
  return (
    <div className='stepButtons'>
      {props.visibleButtons.map((btn) => (
        <button
          onClick={() => props.onSelect(btn.key)}
          className={classnames({
            active: btn.key === props.selected,
          })}
        >
          {btn.label}
        </button>
      ))}
    </div>
  );
};
